import { render, staticRenderFns } from "./employee-wages-list.vue?vue&type=template&id=3719fb3f"
import script from "./employee-wages-list.vue?vue&type=script&lang=js"
export * from "./employee-wages-list.vue?vue&type=script&lang=js"
import style0 from "./employee-wages-list.vue?vue&type=style&index=0&id=3719fb3f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports